import React from "react";
import { Download, FileSpreadsheet } from "lucide-react";
import { AppLayout, PageHeader } from "@/components/AppLayout";
import { API } from "@/lib/api";

const REPORTS = [
  { title: "Receiving Register (full)", desc: "Every receiving line with all 30+ fields.", url: "/exports/receiving.xlsx" },
  { title: "Live Stock On Hand", desc: "Complete bundle-level inventory snapshot.", url: "/exports/stock.xlsx" },
  { title: "Available Stock", desc: "Stock available for allocation.", url: "/exports/stock.xlsx?status=available" },
  { title: "Allocated Stock", desc: "Stock locked to orders.", url: "/exports/stock.xlsx?status=allocated" },
  { title: "Dispatched Stock", desc: "Stock shipped to customers.", url: "/exports/stock.xlsx?status=dispatched" },
  { title: "Damaged Stock", desc: "Damaged or written-off bundles.", url: "/exports/stock.xlsx?status=damaged" },
  { title: "Processing WIP", desc: "Pending and in-progress processing.", url: "/exports/stock.xlsx?status=pending_processing" },
  { title: "Open Orders Report", desc: "All open orders with allocations.", url: "/exports/orders.xlsx" },
  { title: "Dispatch Register", desc: "All dispatches by date.", url: "/exports/dispatches.xlsx" },
  { title: "Invoice Register", desc: "All invoices issued and received.", url: "/exports/invoices.xlsx" },
  { title: "Damages Report", desc: "Damage log with financial impact.", url: "/exports/damages.xlsx" },
  { title: "Audit Trail Export", desc: "Complete activity log.", url: "/exports/audit.xlsx" },
];

export default function Reports() {
  return (
    <AppLayout>
      <PageHeader title="Reports & Exports" subtitle="Download every operational report as Excel." />

      <a href={`${API}/exports/master-workbook.xlsx`} target="_blank" rel="noreferrer"
         className="panel p-5 mb-4 flex items-center justify-between bg-emerald-900 text-white hover:shadow-lg transition-shadow group"
         data-testid="report-master-workbook">
        <div className="flex items-center gap-4">
          <FileSpreadsheet className="h-9 w-9" />
          <div>
            <div className="font-display text-lg font-semibold">Full Master Export (single workbook)</div>
            <div className="text-xs text-emerald-100/90">One Excel with tabs: Receiving · Dispatches · All Stock (incl. dispatched) · Available · Allocated · Code Breakdown.</div>
          </div>
        </div>
        <Download className="h-5 w-5 text-emerald-100 group-hover:text-white" />
      </a>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map((r) => (
          <a key={r.title} href={`${API}${r.url}`} target="_blank" rel="noreferrer"
             className="panel p-5 hover:shadow-md transition-shadow group"
             data-testid={`report-${r.title.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="flex items-start justify-between mb-3">
              <FileSpreadsheet className="h-8 w-8 text-emerald-800" />
              <Download className="h-4 w-4 text-stone-400 group-hover:text-emerald-800" />
            </div>
            <div className="font-display text-base font-semibold mb-1">{r.title}</div>
            <div className="text-xs text-stone-500">{r.desc}</div>
          </a>
        ))}
      </div>
    </AppLayout>
  );
}
